import React from 'react';
import SponsorsForm from './SponsorsForm';

const NewSponsorPage = () => {
    return <SponsorsForm formType="create" />;
};

export default NewSponsorPage;
